// extracted by mini-css-extract-plugin
export default {"container":"JobEstimate_container__Erjz0","body":"JobEstimate_body__JGcPG","itemIconImg":"JobEstimate_itemIconImg__37uG4"};